import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { AuthService } from './_services/auth.service';
import { SystemService } from './_services/system.service';
import { MatrixService } from './_services/matrix.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TimeagoModule } from 'ngx-timeago';
import { AuthGuard } from './_services/auth.guard';
import { EventService } from './_services/event.service';
import { NotifyService } from './_services/notify.service';
import { CodeGuard } from './_services/code.guard';
import { BadgeService } from './_services/badge.service';


@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production
        }),
        BrowserAnimationsModule,
        TimeagoModule.forRoot(),
    ],
    declarations: [AppComponent],
    providers: [
        AuthService,
        SystemService,
        MatrixService,
        EventService,
        NotifyService,
        AuthGuard,
        CodeGuard,
        BadgeService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
